import type { FC, ReactNode } from 'react';

import { useTranslationsLoader } from '@app/hooks/use-translations-loader';
import Loading from '@app/components/legacy/loading';

type Props = {
  language: string;
  children: ReactNode;
};

export const TranslationsLoader: FC<Props> = ({ language, children }: Props) => {
  const { isReady } = useTranslationsLoader(language);

  if (!isReady) {
    return <Loading />;
  }

  return <>{children}</>;
};
